import React, { useState, useContext, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { ModalComp, Time } from "../";
import { Alert } from "../";
import Cookies from "js-cookie";
import {
  addNewScenario,
  scenarioAddWidget,
  scenarioEdit,
  limitList,
  scenariosList,
  scenarioWidgetEdit,
} from "../../api";
import { ScenariosZones } from "./ScenariosZone";
import { useTranslation } from "react-i18next";

const AddScenario = ({
  titleEdit,
  iconEdit,
  uid,
  submit,
  closeAddScenario,
  closeModal,
  props,
  scenarioCommandEdit,
  setScenarioCommandEdit,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen((prevState) => !prevState);
  const [icon, setIcon] = useState(iconEdit || "icon-slepp");
  const [openTimeModal, setOpenTimeModal] = useState(false);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  const toggleTime = () => setOpenTimeModal(!openTimeModal);
  const toggleScenarioZone = () =>
    setOpenScenarioZoneModal(!openScenarioZoneModal);
  const token = Cookies.get("token");
  const [title, setTitle] = useState(titleEdit);
  const [scenarioCommand, setScenarioCommand] = useState([]);
  const [widgetIndex, setWidgetIndex] = useState("");
  const [openScenarioZoneModal, setOpenScenarioZoneModal] = useState(false);
  const [scenarioCommandEdit1, setScenarioCommandEdit1] =
    useState(scenarioCommandEdit);
  let [scenarioCommandCopy, setScenarioCommandCopy] = useState(scenarioCommand);
  const icons = [
    "icon-slepp",
    "icon-muic",
    "icon-in",
    "icon-out",
    "icon-sun",
    "icon-tvv",
  ];
  const toggleAlert = () => {
    setShowAlert((prevState) => ({
      ...prevState,
      show: false,
    }));
  };
  const handleDeleteWidget = (item, i) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    var formdata = new FormData();

    formdata.append("scenariowg_id", item.uid);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch("https://assessn.mmaviot.com/api/scenariowg_remove", requestOptions)
      .then((response) => response.text())
      .then((result) => result)
      .catch((err) => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
          type: "Error",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
        }, 2000);
      });

    const cllose = scenarioCommandEdit.filter((item, index) => index !== i);
    setScenarioCommandEdit(cllose);

    setShowAlert((prevState) => ({
      ...prevState,
      show: true,
      question: false,
      message: t("رویداد مورد نظر شما با موفقیت حذف گردید"),
      type: "Success",
    }));
    setTimeout(() => {
      setShowAlert((prevState) => ({
        ...prevState,
        show: false,
      }));
    }, 2000);
  };

  function handleScenarioTitle(e) {
    setTitle(e.target.value);
  }
  const [scenarioId, setScenarioId] = useState("");
  const [selectWidget, setSelectWidget] = useState(true);

  function handleShowHideFunction() {
    if (title) {
      setOpenScenarioZoneModal(true);
    } else {
      setShowAlert((prevState) => ({
        ...prevState,
        show: true,
        message: t("لطفا یک نام برای سناریوی خود انتخاب نمایید"),
        type: "Warning",
      }));
      setTimeout(() => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: false,
        }));
      }, 5000);
    }
    setSelectWidget(!selectWidget);
  }

  const handleScenarioEdit = () => {
    var data = new FormData();
    data.append("title", title);
    data.append("icon", icon);
    data.append("scenario_id", uid);

    scenarioEdit(data, token)
      .then(() => {
        if (scenarioCommandEdit.length > 0 || scenarioCommand > 0) {
          const serialIndex = {};

          const seenSerials = {};
          let error_serial = false;
          for (let i = 0; i < scenarioCommand.length; i++) {
            const serialCommand = scenarioCommand[i].serial.serial;

            if (!seenSerials[serialCommand]) {
              seenSerials[serialCommand] = true;
            } else {
              error_serial = true;
            }
          }

          for (let i = 0; i < scenarioCommandEdit.length; i++) {
            if (scenarioCommandEdit[i].deleted_at.Valid === false) {
              const serialDevice = scenarioCommandEdit[i].serial_device;

              if (!seenSerials[serialDevice]) {
                seenSerials[serialDevice] = true;
              } else {
                error_serial = true;
              }
            }
          }

          if (error_serial) {
            setShowAlert((prevState) => ({
              ...prevState,
              show: true,
              message: t("عدم ثبت به علت ورود رویداد های تکراری"),
              type: "Error",
              question: false,
            }));
            setTimeout(() => {
              setShowAlert((prevState) => ({
                show: false,
              }));
            }, 5000);
          } else {
            //Save Action Scenario
            //////////////////////
            scenarioCommand.map((item) => {
              var data = new FormData();
              data.append("serial", item.serial.serial);
              data.append("widget", item.id.id);
              data.append("command", item.command.command);
              data.append("scenario_id", uid);
              scenarioAddWidget(data, token)
                .then((result) => result)
                .catch((err) => {
                  if (err.response.status === 403) {
                  }
                  setShowAlert((prevState) => ({
                    ...prevState,
                    show: true,
                    message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
                    type: "Error",
                  }));
                  setTimeout(() => {
                    setShowAlert((prevState) => ({
                      ...prevState,
                      show: false,
                    }));
                  }, 2000);
                });
              // console.log("items list 3: " + item);
            });

            setShowAlert((prevState) => ({
              ...prevState,
              show: true,
              question: false,
              message: t("سناریو با موفقیت ویرایش گردید."),
              type: "Success",
            }));
            setTimeout(() => {
              setShowAlert((prevState) => ({
                ...prevState,
                show: false,
              }));
            }, 2000);
          }

          // console.log("scenarioCommand");
          for (let i = 0; i < scenarioCommand.length; i++) {
            // console.log(scenarioCommand[i].serial.serial);
          }
          // console.log("scenarioCommandEdit");
          for (let i = 0; i < scenarioCommandEdit.length; i++) {
            if (scenarioCommandEdit[i].deleted_at.Valid === false) {
              // console.log(scenarioCommandEdit[i].serial_device);
            }
          }

          /////////////////////////
        } else {
          console.error("Empty list");

          setShowAlert((prevState) => ({
            show: true,
            message: t("ابتدا میبایست رویداد های سناریو را وارد نمایید"),
            type: "Error",
            question: false,
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              show: false,
            }));
          }, 5000);
        }
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("خطا در ویرایش اطلاعات."),
          type: "Error",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
        }, 2000);
      });
  };

  const widgetClicked = (value, index) => {
    setWidgetIndex(index);
  };
  const handleClose = (i) => {
    const cllose = scenarioCommand.filter(
      (index) => index.caption.caption !== i
    );

    setScenarioCommand(cllose);
  };
  const handleEditClose = (i) => {
    const close = scenarioCommandEdit1.filter((index) => {
      return index !== i;
    });
    setScenarioCommandEdit1(close);
  };
  const handleAddScenarioWidget = () => {
    if (scenarioCommandCopy.length > 0) {
      const serialIndex = {};
      for (let i = 0; i < scenarioCommandCopy.length; i++) {
        const currentSerial = scenarioCommandCopy[i].serial.serial;
        // console.log(scenarioCommandCopy[i].serial);
        if (serialIndex[currentSerial] !== undefined) {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("عدم ثبت به علت ورود رویداد های تکراری"),
            type: "Error",
            question: false,
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              show: false,
            }));
          }, 5000);
        } else {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("آیا سناریوی ") + t(`${title}`) + t(" ثبت گردد؟"),
            type: "Warning",
            question: true,
            request: "addNewScenario",
          }));
          setSelectWidget(!selectWidget);
          setScenarioCommandCopy([]);
          serialIndex[currentSerial] = i;
        }
      }
    } else {
      setShowAlert((prevState) => ({
        show: true,
        message: t("ابتدا میبایست رویداد های سناریو را وارد نمایید"),
        type: "Error",
        question: false,
      }));
      setTimeout(() => {
        setShowAlert((prevState) => ({
          show: false,
        }));
      }, 5000);
    }
  };
  useEffect(() => {
    scenarioCommand.map((item) => {
      var data = new FormData();
      data.append("serial", item.serial.serial);
      data.append("widget", item.id.id);
      data.append("command", item.command.command);
      data.append("scenario_id", scenarioId);
      scenarioAddWidget(data, token)
        .then((result) => result)
        .catch((err) => {
          if (err.response.status === 403) {
            Cookies.remove("token");
            props.history.push("/login");
          }
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        });
    });
  }, [scenarioId]);
  useEffect(() => {
    setScenarioCommandCopy(scenarioCommand);
  }, [scenarioCommand]);
  useEffect(() => {
    limitList(token)
      .then((result) => {
        // setScenariosLimit(result.data.data.scenario_count)
        // setScenariosLength(result.data.data.scenario_limit_count)
        // console.log(result.data.data.scenario_count)
        // console.log(scenariosLimit)
        let x =
          result.data.data.scenario_limit_count -
          result.data.data.scenario_count;
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: x
            ? t("شما برای انتخاب ") + t(`${x}`) + t("سناریو دیگر مجاز هستید")
            : t("شما مجاز به انتخاب نیستید"),
          // message: `شما برای انتخاب ${scenariosLimit - scenariosLength} سناریو دیگر مجاز هستید`,
          type: x ? "Warning" : "Error",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
        }, 5000);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <ModalComp
        modal={openTimeModal}
        toggle={toggleTime}
        component={<Time />}
      />
      <ModalComp
        modal={openScenarioZoneModal}
        toggle={toggleScenarioZone}
        component={
          <ScenariosZones
            title={title}
            icon={icon}
            setScenarioCommand={setScenarioCommand}
            scenarioId={scenarioId}
          />
        }
      />

      <div>
        <small> {t("نام سناریو و آیکون دلخواه خود را انتخاب نمایید.")}</small>
      </div>
      <div
        className="addScenarioCard bg-white mb-3 mt-3
       d-flex justify-content-between align-items-center px-3 py-2"
      >
        <div className="text-right ">
          <input
            type="text"
            placeholder={t("اضافه کردن سناریو")}
            className="inputStyle"
            value={title}
            onChange={handleScenarioTitle}
          />
        </div>
        <Dropdown isOpen={isOpen} toggle={toggle}>
          <DropdownToggle className="addScenarioIcon border-0 text-center rounded-circle ">
            <i className={`${icon} text-white`}></i>
          </DropdownToggle>
          <DropdownMenu
            modifiers={{
              setMaxHeight: {
                enabled: true,
                order: 890,
                fn: (data) => {
                  return {
                    ...data,
                    styles: {
                      ...data.styles,
                      overflow: "auto",
                      maxHeight: "100px",
                      fontSize: "20px",
                      textAlign: "right",
                    },
                  };
                },
              },
            }}
          >
            {icons.map((icon) => {
              return (
                <DropdownItem onClick={() => setIcon(icon)}>
                  <i className={icon}></i>
                </DropdownItem>
              );
            })}
          </DropdownMenu>
        </Dropdown>
      </div>

      <div style={{ height: "50vh" }}>
        <div className="scroll ">
          {scenarioCommand.length ? (
            <div>
              <small> {t("رویدادهای انتخاب شده:")}</small>
            </div>
          ) : (
            ""
          )}
          <div>
            {scenarioCommand?.map((item, index) => {
              let active = widgetIndex === index ? "selectZonesActive" : "";
              const widgetId = item;
              // console.log(widgetId);
              return (
                <div>
                  <div
                    onClick={() => widgetClicked(item, index)}
                    key={index}
                    className={`selectWidget 
           text-center py-2 my-2 cursor ${active}`}
                  >
                    <div className="d-flex border-bottom-4 justify-content-between px-2">
                      <label className="  ">
                        {item.caption.caption}
                        {" : "}
                        {item.command.command === "10" ? t("روشن") : t("خاموش")}
                      </label>
                      <button
                        className="btn-close "
                        onClick={() => {
                          handleClose(item.caption.caption);
                        }}
                      ></button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {submit ? (
          <>
            <div>
              {scenarioCommandEdit?.map((item, index) => {
                let active = widgetIndex === index ? "selectZonesActive" : "";
                let itemDelete = item.deleted_at.Valid === true ? "d-none" : "";
                return (
                  <div>
                    <div
                      onClick={() => {
                        handleDeleteWidget(item, index);
                      }}
                      key={index}
                      className={`selectZones 
                text-center py-2 my-2 cursor d-flex
                 border-bottom-4 justify-content-between text-black px-2
                  ${itemDelete}  ${active}`}
                    >
                      <div
                        className="d-flex border-bottom-4 justify-content-between
                     px-2"
                      >
                        <label className="">
                          {item.zone_widget_caption}
                          {":"}
                          {item.command === "10" ? t("روشن") : t("خاموش")}
                        </label>
                      </div>
                      <button
                        className="btn-close "
                        onClick={() => {
                          handleEditClose(index);
                        }}
                      ></button>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Edit Scenario */}
            <div className="d-flex justify-content-center align-items-center ">
              <div
                className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
                onClick={handleShowHideFunction}
              >
                <span className="profileAddUser bg-white d-block cursor">
                  +
                </span>
                <small className="fn12 mt-1">{t("رویداد")}</small>
              </div>

              <div
                className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
                onClick={handleScenarioEdit}
              >
                <span className="profileAddUser bg-white d-block icon-ok cursor"></span>
                <small className="fn12 mt-1">{t("ثبت")}</small>
              </div>
            </div>
            {/* End Edit Scenario */}
          </>
        ) : (
          <div className="d-flex justify-content-center align-items-center ">
            <div
              className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
              onClick={handleShowHideFunction}
            >
              <span className="profileAddUser bg-white d-block cursor">+</span>
              <small className="fn12 mt-1">{t("رویداد")}</small>
            </div>

            <div
              className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
              onClick={handleAddScenarioWidget}
            >
              <span className="profileAddUser bg-white d-block icon-ok cursor"></span>
              <small className="fn12 mt-1">{t("ثبت")}</small>
            </div>
          </div>
        )}
      </div>

      {showAlert.show && (
        <Alert
          message={showAlert.message}
          type={showAlert.type}
          title={title}
          icon={icon}
          setScenarioId={setScenarioId}
          question={showAlert.question}
          request={showAlert.request}
          close1={closeAddScenario}
          toggleAlert={toggleAlert}
        />
      )}
    </>
  );
};

export { AddScenario };
